import React from "react";
import { Box, FormControl } from "@material-ui/core";

interface HtmlReadOnlyProps {
    html: string;
}

export const HtmlReadOnly = ({ html }: HtmlReadOnlyProps) => {
    return (
        <FormControl fullWidth={true}>
            <Box dangerouslySetInnerHTML={{ __html: html }} />
        </FormControl>
    );
};
